module.exports = __webpack_public_path__ + "img/8-World Media Group.2fde4c72.png";